import type { GlobalSearchResponse } from '@lens/shared';
import { apiRequest } from '../../shared/api/client.ts';

/**
 * Глобальный поиск «Поиск везде» — `GET /api/search` (см.
 * `docs/api-design.md §«Глобальный поиск»`).
 *
 * Контракт допускает свободный вызов: при `q.trim().length < 2` сервер
 * отдаёт 200 с пустыми массивами, так что дебаунс на стороне UI может не
 * проверять длину перед запросом (но мы всё равно проверяем — чтобы не
 * слать заведомо пустые запросы). `limit` — лимит НА КАЖДУЮ категорию.
 *
 * GET → CSRF не нужен. `signal` пробрасывается в `fetch` для отмены
 * устаревших запросов при дебаунсе (AbortError игнорируется вызывающим).
 */
export function globalSearch(
  q: string,
  signal?: AbortSignal,
): Promise<GlobalSearchResponse> {
  const params = new URLSearchParams({ q, limit: '8' });
  return apiRequest<GlobalSearchResponse>(`/api/search?${params.toString()}`, {
    method: 'GET',
    signal,
  });
}
